import { DIAGRAM_EMIT_EVENTS } from "../../../../diagram/modules/DiagramEvents";
import { FabricRectangular } from "../../../../views/grid/components/FabricRectangular";

import { roundRect } from "../../../../utils/utils";
import { DATA_MODEL_PROPERTY_LABEL_STYLE } from "./config/property.config";
import { ClassText } from "./ClassText";
import { DiagramUtils } from "../../../../diagram/diagram-assets/DiagramUtils";

export class ClassProperty extends FabricRectangular {
    layout = {
        width: null, height: null, x: null, y: null
    };

    state = { selected: false, drawed: false };

    ctx;

    data;

    uuid;

    labelStyle = DATA_MODEL_PROPERTY_LABEL_STYLE;

    labelInstance;

    constructor(layout, state, ctx, data) {
        super(layout);
        this.layout = layout;
        if (state) this.state = { ...this.state, ...state };
        this.ctx = ctx;
        this.data = data || {};
        if (this.data.uuid) {
            this.uuid = data.uuid;
            delete data.uuid;
        } else this.uuid = new DiagramUtils().generateUUID();
    }

    draw() {
        if (this.state.drawed) {
            this.clear();
        }
        this.state.drawed = true;
        const style = { fillStyle: this.state.selected || this.state.active ? "#4285F4" : "#FFFFFF" };
        const x = this.layout.x + 1.5;
        const y = this.layout.y + 1;
        const height = this.layout.height - 1;
        const { width } = this.layout;
        this.drawBorder(x, y, width, height);
        roundRect(x + 2, y + 1, width - 4, height - 1, 0, style, this.ctx);
        this.drawLabel();
    }

    getSize() {
        return { width: this.layout.width, height: this.layout.height };
    }

    getPosition() {
        return { x: this.layout.x, y: this.layout.y };
    }

    drawLabel() {
        const layout = {
            x: this.layout.x + 3, y: this.layout.y, width: this.layout.width - 5, height: this.layout.height
        };
        const style = DATA_MODEL_PROPERTY_LABEL_STYLE;
        if (!this.labelInstance) {
            this.labelInstance = new ClassText(this.state, layout, style, this.ctx, this.data.label);
        } else {
            this.labelInstance.update(this.state, layout, null, this.data.label);
        }
        this.labelInstance.draw();
    }

    drawBorder(xPos, yPos, width, height, thickness = 1) {
        this.ctx.strokeStyle = "#EEEEEE";
        this.ctx.beginPath();
        this.ctx.moveTo(xPos + 2, yPos - 1);
        this.ctx.lineTo(xPos + width - 4, yPos - 1);
        this.ctx.stroke();
        this.ctx.closePath();

        this.ctx.beginPath();
        this.ctx.moveTo(xPos + 2, yPos + height + 1);
        this.ctx.lineTo(xPos + width - 4, yPos + height + 1);
        this.ctx.stroke();
        this.ctx.closePath();

        // this.ctx.fillStyle = '#EEEEEE';
        // this.ctx.fillRect(xPos - (thickness), yPos - (thickness), width + (thickness * 2), height + (thickness * 2));
    }

    clear() {
        this.state.drawed = false;
        this.ctx.clearRect(this.layout.x + 6, this.layout.y, this.layout.width - 7, this.layout.height);
    }

    update(layout, state, data) {
        if (layout) {
            this.layout = { ...this.layout, ...layout };
            this.setPoints(this.layout);
        }
        if (state) this.state = { ...this.state, ...state };
        if (data) this.data = { ...this.data, ...data };
    }

    emitUpdateLabelEvent(eventEmitter, containerUuid, childUuid, oldLabel) {
        if (eventEmitter) {
            const newLabel = this.data.label[0].text.substring(0, this.data.label[0].text.length - 1);
            if (newLabel !== oldLabel) {
                const { oldState } = this.data;
                eventEmitter.emitEvent(DIAGRAM_EMIT_EVENTS.CONTAINER_CHILD_UPDATED,
                    {
                        DATA_MODEL_UUID: containerUuid, DATA_PROPERTY_UUID: this.uuid, DATA_PROPERTY_ID: this.data.id, DATA_PROPERTY_LABEL: newLabel
                    }, false, true);
                eventEmitter.emitEvent(DIAGRAM_EMIT_EVENTS.MULTIPLE_ACTIONS_HAPPENED, [
                    { event: DIAGRAM_EMIT_EVENTS.CONTAINER_CHILD_UPDATED, oldState, payload: { DATA_MODEL_UUID: this.data.uuid, DATA_MODEL_ID: this.data.id, DATA_MODEL_LABEL: this.data.label } }
                ], true, false);
            }
        }
    }

    getPropertyLabel() {
        return this.data.label && this.data.label[0] ? this.data.label[0].text.substring(0, this.data.label[0].text.length - 1) : "";
    }
}
